<template>
  <div class="container mx-auto my-8 px-4 md:px-0" v-if="isLoaded">
    <base-form :do="save" :v-errors="error" class="flex flex-col md:flex-row md:-mx-4">

      <div class="w-full bg-white content shadow mb-6 md:mx-4 md:w-2/3">
        <div class="group">
          <div class="caption">
            <h5 class="text-base font-semibold font-medium text-green-dark">Organisatie</h5>
          </div>

          <div class="fields flex flex-col w-full p-6">
            <div class="flex flex-wrap mx-0 md:-mx-2">
              <text-input class="w-full md:w-1/2 md:px-2" label="Naam" name="name" type="text"
                v-model="organization.name"
                v-validate="'required'"
                data-vv-as="Naam"
                :error="errors.first('name')"
                :has-permission="true"
                :required="true"
              ></text-input>
              <text-input class="w-full md:w-1/2 md:px-2 mb-4" label="Telefoon" name="phone" type="text"
                v-model="organization.phone"
                data-vv-as="Telefoon"
                :error="errors.first('phone')"
                :has-permission="true"
              ></text-input>
            </div>

            <div class="flex flex-wrap mx-0 md:-mx-2">
              <text-input class="w-full md:w-3/4 md:px-2" label="Straat" name="street" type="text"
                v-model="organization.street"
                data-vv-as="Straat"
                :error="errors.first('street')"
                :has-permission="true"
              ></text-input>
              <text-input class="w-full md:w-1/4 md:px-2 mb-4" label="Huisnummer" name="house_number" type="text"
                v-model="organization.house_number"
                :has-permission="true"
              ></text-input>
            </div>

            <div class="flex flex-wrap mx-0 md:-mx-2">
              <text-input class="w-full md:w-1/2 md:px-2" label="Postcode" name="postal_code" type="text"
                v-model="organization.postal_code"
                :has-permission="true"
              ></text-input>
              <text-input class="w-full md:w-1/2 md:px-2" label="Stad" name="city" type="text"
                v-model="organization.city"
                :has-permission="true"
              ></text-input>
            </div>
          </div>
        </div>
        <div class="flex w-full px-6 py-6 bg-grey-lightest border-t border-grey-lighter flex items-center">
          <button v-if="!isNew" tabindex="-1" type="button" class="text-sm text-red hover:underline" @click="destroy()">
            <span>Verwijder</span>
            <span class="hidden md:inline ml-1">Organisatie</span>
          </button>
          <button type="submit" class="btn py-3 text-sm text-white bg-green-dark font-semibold ml-auto">
            <span>{{ isNew ? 'Bewaren' : 'Wijzig' }}</span>
            <span class="hidden md:inline ml-1">Organisatie</span>
          </button>
        </div>
      </div>

      <div class="flex flex-col w-full z-0 md:mx-4 md:w-1/3" v-if="organization.created_at">
        <!-- CREATED -->
        <div class="w-full mb-4 shadow" style="background-color: #e7eef3;">
          <div class="field w-full px-4 pt-4 pb-2">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gemaakt op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ organization.created_at }}</span>
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2 pb-4">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gewijzigd op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ organization.updated_at }}</span>
            </div>
          </div>
        </div>
      </div>

    </base-form>

    <base-notification
      :type="notification.type"
      :message.sync="notification.message">
    </base-notification>

    <div class="w-full bg-white content shadow mt-6 overflow-x-auto" v-if="!isNew">
      <div class="group">
        <div class="caption flex items-center justify-between">
          <h5 class="text-base font-semibold font-medium text-green-dark">Gebruikers</h5>
          <router-link :to="{ name: 'user-new', params: { id: organization.id } }" class="flex items-center text-sm hover:underline text-green-darker">
            Nieuw Gebruiker
          </router-link>
        </div>

        <table class="custom w-full whitespace-no-wrap">
          <thead v-if="organization.users.length > 0">
            <tr class="text-left text-green-darker">
              <th class="px-6">Naam</th>
              <th class="px-6" colspan="2">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in organization.users" :key="user.id" class="hover:bg-grey-lightest text-grey-darker">
              <td class="border-t border-grey-lighter">
                <router-link :to="{ name: 'user', params: { id: organization.id, user_id: user.id } }" class="flex items-center px-6 py-4">
                  {{ user.name }}
                </router-link>
              </td>
              <td class="border-t border-grey-lighter">
                <router-link :to="{ name: 'user', params: { id: organization.id, user_id: user.id } }" class="flex items-center px-6 py-4">
                  {{ user.email }}
                </router-link>
              </td>
              <td class="border-t border-grey-lighter w-px">
                <router-link :to="{ name: 'user', params: { id: organization.id, user_id: user.id } }" class="flex items-center px-6 py-4">
                  <font-awesome-icon :icon="['fas', 'angle-right']" class="icon" />
                </router-link>
              </td>
            </tr>
            <tr v-if="organization.users.length === 0">
              <td class="px-6 py-4" colspan="4">Geen gebruikers gevonden.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  <div class="w-full bg-white content shadow mt-6" v-if="!isNew">
      <div class="group">
        <div class="w-full px-6 py-3 border-b border-grey-lighter flex items-center justify-between">
          <h5 class="text-base font-semibold font-medium text-green-dark mr-4">Complexen</h5>
          <div class="relative border rounded px-4 py-1 w-full lg:w-1/4">
            <input class="text w-full" style="padding-right: 60px;" type="text" v-on:keyup.enter="searchComlexes" :value="complex && complex.name" placeholder="Zoek een complex...">
            <button type="button" class="absolute z-10 pin-r pin-y text-grey-dark text-xs flex items-center" style="font-size: .6rem;" @click="linkComplex">
              <span class="ml-2 px-2 py-1 h-full border-l-2 font-semibold tracking-wide uppercase">Koppel</span>
            </button>
            <div class="absolute rounded z-30 bg-white border pin-r pin-l mt-3 overflow-y-auto" v-if="results.length" style="max-height: 103px;">
              <div class="px-2 py-2 text-sm text-grey-darker">
                <button type="button" v-for="complex in results" :key="complex.id" @click="selectComplexResult(complex)" class="text-left inline-block w-full px-3 py-2 mt-1 hover:bg-grey-lighter rounded">
                  {{ complex.name }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full overflow-x-auto">
          <table class="custom w-full whitespace-no-wrap">
            <thead v-if="complexes.length > 0">
              <tr class="text-left text-green-darker">
                <th class="px-6">Naam</th>
                <th class="px-6 text-right">Aantal woningen</th>
                <th class="px-6 text-right">Aantal bronnen aanwezig</th>
                <th class="px-6 text-right">Aantal bronnen verwijderd</th>
                <th class="px-6" colspan="2"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="complex in complexes" :key="complex.id" class="hover:bg-grey-lightest text-grey-darker">
                <td class="border-t border-grey-lighter">
                  <router-link :to="{ name: 'complex', params: { id: complex.id } }" class="flex items-center px-6 py-4 max-w-xs">
                    <span class="truncate">{{ complex.name }}</span>
                  </router-link>
                </td>
                <td class="border-t border-grey-lighter">
                  <router-link :to="{ name: 'complex', params: { id: complex.id } }" class="flex items-center justify-end px-6 py-4">
                    {{ complex.residence_count }}
                  </router-link>
                </td>
                <td class="border-t border-grey-lighter">
                  <router-link :to="{ name: 'complex', params: { id: complex.id } }" class="flex items-center justify-end px-6 py-4">
                    {{ complex.sources_present_count }}
                  </router-link>
                </td>
                <td class="border-t border-grey-lighter">
                  <router-link :to="{ name: 'complex', params: { id: complex.id } }" class="flex items-center justify-end px-6 py-4">
                    {{ complex.sources_removed_count }}
                  </router-link>
                </td>
                <td class="border-t border-grey-lighter w-px">
                  <router-link :to="{ name: 'complex', params: { id: complex.id } }" class="flex items-center px-6 py-4">
                    <font-awesome-icon :icon="['fas', 'angle-right']" class="icon" />
                  </router-link>
                </td>
              </tr>
              <tr v-if="complexes.length === 0">
                <td class="px-6 py-4" colspan="4">Geen complexen gevonden.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import ContactService from '@/services/contact';
import ContactPerimeters from '@/perimeters/contact';
import ComplexService from '@/services/complex';

import BaseForm from '@/components/globals/BaseForm';
import BaseNotification from '@/components/globals/BaseNotification';
import TextInput from '@/components/inputs/Text';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'OrganizationEdit',
  perimeters: [ContactPerimeters],
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    BaseNotification,
    TextInput,
    FontAwesomeIcon
  },
  data() {
    return {
      organization: {
        users: []
      },
      complexes: [],
      error: null,
      notification: {
        type: 'info',
        message: ''
      },
      isNew: false,
      results: [],
      complex: null
    };
  },
  async created() {
    await this.fetch();
  },
  computed: {
    isLoaded() {
      return this.isNew || (!this.isNew && this.organization.id);
    }
  },
  methods: {
    fetch() {
      if (!this.$route.params.id) {
        return (this.isNew = true);
      }

      this.fetchComplexes();

      return ApiService.get(
        `/v1/contacts/${this.$route.params.id}?include=users`
      ).then(
        response =>
          (this.organization = { ...this.organization, ...response.data.data })
      );
    },

    selectComplexResult(complex) {
      this.complex = complex;
      this.results = [];
    },

    async linkComplex() {
      try {
        this.complex.owner_id = this.organization.id;

        await ComplexService.save(this.complex.id, this.complex);

        this.notification.type = 'success';
        this.notification.message = 'Complex gekoppeld';
      } catch (response) {
        this.error = response.data;

        this.notification.type = 'error';
        this.notification.message = 'Complex niet gekoppeld';
      }

      this.complex = null;
    },

    async searchComlexes(event) {
      const keyword = event.target.value;

      if (keyword.length < 1) {
        return (this.results = []);
      }

      const url = `/v1/complexes?filter[name]=${keyword}`;

      const { data } = await ApiService.query(url).catch(
        () => (this.results = [])
      );

      this.results = data.data;
    },

    async fetchComplexes() {
      const url = `/v1/complexes?limit=1000&filter[owner_org_id]=
        ${this.$route.params.id}
      `;
      const { data } = await ApiService.query(url).catch(
        () => (this.complexes = [])
      );

      this.complexes = data.data;
    },

    async save() {
      try {
        await ContactService.save(this.organization.id, this.organization);

        this.notification.type = 'success';
        this.notification.message = 'Organisatie opgeslagen.';

        return this.$router.push({ name: 'organizations' });
      } catch (response) {
        this.error = response.data;

        this.notification.type = 'error';
        this.notification.message = 'Organisatie niet opgeslagen.';
      }
    },

    async destroy() {
      if (confirm('Weet u zeker dat u deze organisatie wilt verwijderen?')) {
        try {
          await ContactService.delete(this.organization.id);
          return this.$router.push({ name: 'organizations' });
        } catch (response) {
          this.error = response.data;

          this.notification.type = 'error';
          this.notification.message = 'Organisatie niet verwijderd.';
        }
      }
    }
  }
};
</script>
